import React from 'react';

interface ErrorAlertProps {
  errorMessage: string;
  onRetry?: () => void;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ errorMessage, onRetry }) => {
  const getSuggestion = (error: string): string | null => {
    const lowerError = error.toLowerCase();

    if (lowerError.includes('api key') || lowerError.includes('authentication')) {
      return 'Schakel over naar de Mock provider voor testen zonder API key';
    }

    if (lowerError.includes('rate limit') || lowerError.includes('quota')) {
      return 'Je hebt de API limiet bereikt. Probeer het over enkele minuten opnieuw';
    }

    if (lowerError.includes('timeout') || lowerError.includes('timed out')) {
      return 'De generatie duurde te lang. Probeer een kortere video duur';
    }

    if (lowerError.includes('runway') && lowerError.includes('secret')) {
      return 'Runway API key ontbreekt. Gebruik Sora of Mock provider';
    }

    if (lowerError.includes('openai') || lowerError.includes('sora')) {
      return 'OpenAI API key ontbreekt. Gebruik Runway of Mock provider';
    }

    return null;
  };

  const suggestion = getSuggestion(errorMessage);

  return (
    <div className="mt-4 p-4 bg-red-900 bg-opacity-20 border border-red-600 rounded-lg">
      <div className="flex items-start">
        <div className="flex-shrink-0 text-2xl mr-3">❌</div>
        <div className="flex-1">
          <h3 className="text-red-400 font-medium mb-1">Video generatie mislukt</h3>
          <p className="text-sm text-red-300 mb-3">{errorMessage}</p>

          {suggestion && (
            <div className="p-2 bg-yellow-900 bg-opacity-20 border border-yellow-600 rounded mb-3">
              <div className="flex items-start">
                <span className="text-yellow-400 mr-2">💡</span>
                <p className="text-sm text-yellow-300">{suggestion}</p>
              </div>
            </div>
          )}

          {onRetry && (
            <button onClick={onRetry} className="btn-secondary text-sm">
              Probeer opnieuw
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorAlert;
